import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { SxProps, Theme } from '@mui/material'
import { StepProps } from '../../../../components/_WMS/Stepper'
import { SharedStateType } from '../../types'

interface ErrorMessageProps extends StepProps<SharedStateType> {}

const errorStyles: Record<string, SxProps<Theme>> = {
  root: {
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'background.default'
  },
  errorText: {
    color: '#B71C1C',
    backgroundColor: '#fdecea',
    padding: 2,
    borderRadius: 1,
    textAlign: 'center',
    maxWidth: '80%'
  }
}

export const ErrorStep: React.FC<ErrorMessageProps> = ({
  prev,
  sharedState: { error }
}) => {
  return (
    <Box sx={errorStyles.root}>
      <Typography variant='h6' sx={errorStyles.errorText}>
        {error}
      </Typography>
      <Button onClick={prev}>Volver</Button>
    </Box>
  )
}
